import { PipeTransform, Pipe } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ProgramExitTypeNature } from '../../enums/program-exit-type-nature.enum';

@Pipe({
  name: 'programExitTypeNature',
  standalone: false
})
export class ProgramExitTypeNaturePipe implements PipeTransform {
  public transform(value: ProgramExitTypeNature): string {
    return getProgramExitTypeNature(value);
  }
}

export function getProgramExitTypeNature(value: ProgramExitTypeNature): string {
  switch (value) {
    case ProgramExitTypeNature.Pass:
      return 'Pass';
    case ProgramExitTypeNature.Fail:
      return 'Fail';
    default:
      throw new Error(`Unsupported value for ProgramExitTypeNature: ${value}.`);
  }
}

export function getProgramExitTypeNatureImage(
  value: ProgramExitTypeNature,
  domSanitizer: DomSanitizer
): SafeResourceUrl {
  let result;

  switch (value) {
    case ProgramExitTypeNature.Fail:
      result =
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiNGNzAwMEYiLz48cmVjdCB4PSI0IiB5PSI3IiB3aWR0aD0iOCIgaGVpZ2h0PSIyIiBmaWxsPSIjRkZGRkZGIi8+PC9zdmc+';
      break;
    case ProgramExitTypeNature.Pass:
      result =
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiMwOUFGMDAiLz48cmVjdCB4PSI0IiB5PSI3IiB3aWR0aD0iOCIgaGVpZ2h0PSIyIiBmaWxsPSIjRkZGRkZGIi8+PHJlY3QgeD0iNyIgeT0iNCIgd2lkdGg9IjIiIGhlaWdodD0iOCIgZmlsbD0iI0ZGRkZGRiIvPjwvc3ZnPg==';
      break;
    default:
      throw new Error(`Unsupported value for ProgramExitTypeNature: ${value}.`);
  }

  return domSanitizer.bypassSecurityTrustResourceUrl(result);
}
